// extracted by mini-css-extract-plugin
export default {"scrollBar":"scroll-bar_scrollBar__ZLx8G"};